import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => void, delay: number | null) => {
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        let id: ReturnType<typeof setInterval> | null = null;

        if (delay) {
            id = setInterval(() => savedCallback.current(), delay);
        }

        return () => {
            if (id) {
                clearInterval(id);
            }
        };
    }, [delay]);
};
